module.exports = __webpack_public_path__ + "img/infor2.4f499680.png";